"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Search_1 = require("./partials/Search");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const HomeStore_1 = require("../stores/HomeStore");
const BlogActions_1 = require("../actions/BlogActions");
const dateFormat = require('dateformat');
const $ = require('jquery');
class Home extends React.Component {
    constructor(props) {
        super(props);
        this.isMapLoaded = false;
        this.map = null;
        this.setMapRef = (element) => {
            this.map = element;
        };
    }
    componentDidUpdate() {
        this.loadMap();
    }
    componentDidMount() {
        this.loadMap();
    }
    goToPost(slug) {
        this.props.executeAction(BlogActions_1.default.navigateToCurrentPost, { slug });
    }
    loadMap() {
        const self = this;
        (function ($, window, document, undefied) {
            'use strict';
            const listDestination = [];
            const listLocation = [];
            for (const category of self.props.mapLocs) {
                listDestination.push(category._id);
                for (const elem of category.elems) {
                    listLocation.push({
                        destination: category._id,
                        locationCenter: true,
                        info: {
                            content: '<div class="post">\
                                <div class="post-media">\
                                    <div class="image-wrap">\
                                        <img src="' + elem.image + '" alt="Image" />\
                                    </div>\
                                    <div class="post-format"><a href="/post/' + elem.slug + '"><i class="fa fa-image"></i></a></div>\
                                </div>\
                                <div class="post-body">\
                                    <div class="post-title">\
                                        <h2><a class="post-title-click" data-slug="' + elem.slug + '" href="/post/' + elem.slug +
                                '" >' + elem.title + '</a></h2>\
                                    </div>\
                                    <div class="post-date">\
                                        <span>' + dateFormat(elem.date, 'mmmm dS, yyyy') + '</span>\
                                    </div>\
                                </div>\
                            </div>',
                        },
                        marker: {
                            bounce: false,
                            icon: '/public/img/location.png',
                            position: [elem.geo[1], elem.geo[0]],
                            title: elem.title,
                        },
                        name: elem.title,
                    });
                }
            }
            if (self.props.mapLocs.length === 0 || self.isMapLoaded) {
                return;
            }
            self.isMapLoaded = true;
            $('.map').on('click', '.post-title-click', (e) => {
                e.preventDefault();
            });
            $('.map').on('mouseup', '.post-title-click', function (e) {
                switch (e.which) {
                    case 1:
                        e.preventDefault();
                        self.goToPost($(this).data('slug'));
                        break;
                }
            });
            $(self.map).piMapExtend({
                zoom: 3,
                scrollwheel: false,
                titleDesktop: '<h2 id="pi_map_sidebar_title">' + 'Destination' + '<i class="fa fa-angle-down"></i></h2>',
                titleMobile: 'Destination',
                showListLocation: true,
                responsiveMobile: 768,
                listLocation,
                listDestination,
                extendStyle: {
                    mapbox: {
                        bgPreview: 'rgba(184, 203, 147, 1)',
                        title: 'Mapbox',
                        content: [{
                                featureType: 'water',
                                stylers: [{ saturation: 43 }, { lightness: -11 }, { hue: '#0088ff' }],
                            }, {
                                featureType: 'road',
                                elementType: 'geometry.fill',
                                stylers: [{ hue: '#ff0000' }, { saturation: -100 }, { lightness: 99 }],
                            }, {
                                featureType: 'road',
                                elementType: 'geometry.stroke',
                                stylers: [{ color: '#808080' }, { lightness: 54 }],
                            }, {
                                featureType: 'landscape.man_made',
                                elementType: 'geometry.fill',
                                stylers: [{ color: '#ece2d9' }],
                            }, {
                                featureType: 'poi.park',
                                elementType: 'geometry.fill',
                                stylers: [{ color: '#ccdca1' }],
                            }, {
                                featureType: 'road',
                                elementType: 'labels.text.fill',
                                stylers: [{ color: '#767676' }],
                            }, {
                                featureType: 'road',
                                elementType: 'labels.text.stroke',
                                stylers: [{ color: '#ffffff' }],
                            }, {
                                featureType: 'poi',
                                stylers: [{ visibility: 'off' }],
                            }, {
                                featureType: 'landscape.natural',
                                elementType: 'geometry.fill',
                                stylers: [{ visibility: 'on' }, { color: '#b8cb93' }],
                            }, {
                                featureType: 'poi.park',
                                stylers: [{ visibility: 'on' }],
                            }, {
                                featureType: 'poi.sports_complex',
                                stylers: [{ visibility: 'on' }],
                            }, {
                                featureType: 'poi.medical',
                                stylers: [{ visibility: 'on' }],
                            }, { featureType: 'poi.business', stylers: [{ visibility: 'simplified' }] }],
                    },
                },
                styleActive: 'blueGray',
                beforeResize(obj) {
                    const $el = obj.el, options = obj.options, wh = $(window).height(), ww = window.innerWidth, heightHeader = $('#header').outerHeight(), heightSearch = $('.search-section').outerHeight();
                    if (wh > (heightHeader + heightSearch)) {
                        $el.height(wh - (heightHeader + heightSearch));
                    }
                    if (ww < 1400) {
                        $el.height(wh - heightHeader);
                        $('.pi-scrollto').show();
                    }
                    else {
                        $('.pi-scrollto').hide();
                    }
                },
                initMap: (obj) => {
                    obj.map.setCenter(new window.google.maps.LatLng(45.464664, 9.188540));
                    $(window).trigger('resize');
                },
            });
        })($, window, document);
    }
    render() {
        return (React.createElement("div", null,
            React.createElement("div", { className: 'map', ref: this.setMapRef }),
            React.createElement(Search_1.default, { executeAction: this.props.executeAction })));
    }
}
class HomeProps {
}
exports.default = (0, fluxible_addons_react_1.connectToStores)(Home, [HomeStore_1.default], (context, props) => {
    return {
        mapLocs: context.getStore(HomeStore_1.default).getMapLocs(),
        executeAction: context.executeAction,
    };
});
